import { render } from "./SmartFormSection.vue?vue&type=template&id=166bdcbe&ts=true"
import script from "./SmartFormSection.vue?vue&type=script&lang=ts"
export * from "./SmartFormSection.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__